/**
 * The notice at the top of Teacher Home — docs/06-UI-SPEC.md §5, SRS I2.
 *
 * A teacher who shuts the laptop at the end of a class never taps End Session. The
 * server closes the lesson for them twenty minutes later and saves it; this is where
 * they find that out, so a lesson that seemed to vanish is accounted for the next
 * time they sign in.
 */

import type { RecoveredLesson } from '../api.js';
import { recoveryMessage } from '../recovery-notice.js';

export interface RecoveryBannerProps {
  readonly lesson: RecoveredLesson;
  /** Opens the Lecture Record, where the saved lesson is filed. */
  readonly onView: () => void;
  readonly onDismiss: () => void;
}

export function RecoveryBanner({ lesson, onView, onDismiss }: RecoveryBannerProps) {
  return (
    <div
      role="status"
      aria-live="polite"
      className="
        flex w-full max-w-[640px] flex-wrap items-center gap-4 rounded-lg
        border border-border bg-primary-subtle px-4 py-3 text-base text-text-primary
      "
    >
      <p className="flex-1 min-w-[240px]">{recoveryMessage(lesson)}</p>
      <button
        type="button"
        onClick={onView}
        className="
          h-touch rounded-md bg-surface px-4 text-base font-medium text-text-primary
          transition duration-fast ease-out hover:bg-surface-hover
        "
      >
        View
      </button>
      <button
        type="button"
        onClick={onDismiss}
        aria-label="Dismiss this notice"
        className="
          h-touch w-touch rounded-md text-lg text-text-secondary
          transition duration-fast ease-out hover:bg-surface-hover
        "
      >
        ×
      </button>
    </div>
  );
}
